module.exports = __webpack_public_path__ + "static/media/substation.c1731218.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/substation.svg
// module id = 301
// module chunks = 0